<template>
	<div class="brand-wrapper">
		<div class="brand-image">
			<img :src="image" :alt="brand.name" />
		</div>
		<div class="brand-name">{{ brand.name }}</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('productInfo', ['brand']),
		image() {
			return this.brand.image ?? require('@/assets/images/no-image-small.jpg')
		},
	},
}
</script>

<style lang="scss" scoped>
.brand-wrapper {
	display: flex;
	align-items: center;
	width: 100%;
	height: 76px;
	border: 1px solid #e6eaee;
	border-radius: 10px;
	background: #fff;
	overflow: hidden;

	/* 브랜드 이미지: 기존(120x40)보다 크게 */
	.brand-image {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 190px;
		width: 190px;
		height: 100%;
		padding: 8px 16px;
		border-right: 1px solid #eef1f4;
		img {
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
		}
	}

	.brand-name {
		padding: 0 22px;
		font-size: 1.1rem;
		font-weight: 800;
		color: #111827;
		letter-spacing: 0.01em;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
</style>
